import styled from "@emotion/styled";
import { CasinoCardsIcon } from "src/ui/assets/icons/casino/CasinoCardsIcon";
import { Button } from "src/ui/components/button/common/Button";
import { withConfig } from "src/withConfig";

export const XtremePushBonusContainer = withConfig(theme => styled('div', { label: 'XtremePushBonusContainer' })`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: ${theme.star.padding.medium};
    background: ${theme.star.heroEvents.bgColorTertiary};
`);

export const XtremePushBannerTitleWrapper = styled('div', { label: 'XtremePushBannerTitleWrapper' })`
    display: flex;
    flex-flow: column nowrap;
`;

export const XtremePushBannerHeader = withConfig(theme => styled('h2', { label: 'XtremePushBannerHeader' })`
    font-weight: ${theme.star.fontWeight.bold};
    font-size: ${theme.star.fontSize.regular};
    line-height: 1.5;
    margin: 0;
`);

export const XtremePushBannerDisclaimer = withConfig(theme => styled('p', { label: 'XtremePushBannerDisclaimer' })`
    font-size: ${theme.star.fontSize.xSmall};
    line-height: 1.2;
    margin: 0;
`);

export const XtremePushBannerHeaderWrapper = withConfig(theme => styled('div', { label: 'XtremePushBannerHeaderWrapper' })`
    display: flex;
    align-items: center;
    gap: ${theme.star.gap.medium};
`);

export const XtremePushBannerButton = withConfig(theme => styled(Button, { label: 'XtremePushBannerButton' })`
    font-weight: ${theme.star.fontWeight.bold};
    background: ${theme.star.heroEvents.bgColorSeptenary};
    color: ${theme.star.heroEvents.txtColor};
    padding: ${theme.star.padding.medium} ${theme.star.padding.xMedium};
`);

export const XtremePushBannerIcon = withConfig(theme => styled(CasinoCardsIcon, { label: 'XtremePushBannerIcon' })`
    color: ${theme.star.heroEvents.txtColor};
`);
